module.exports = __webpack_public_path__ + "img/coin_BS.db08b2f2.png";